import { render, staticRenderFns } from "./MatriculasEdInfantilCard.vue?vue&type=template&id=0903459d&scoped=true"
import script from "./MatriculasEdInfantilCard.vue?vue&type=script&lang=js"
export * from "./MatriculasEdInfantilCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasEdInfantilCard.vue?vue&type=style&index=0&id=0903459d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0903459d",
  null
  
)

export default component.exports